export default __webpack_public_path__ + "static/media/logo.01c5241a.svg";